import { Vue, Component, Ref } from 'vue-property-decorator'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import i18n from '@/lang/i18n'
import { GetContextMenuItemsParams, GridOptions, MenuItemDef } from '@ag-grid-enterprise/all-modules'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import ConceptsModalBreakdownsBasicForm from '@/modules/configurationModule/detail/local-accounting/non-billable/concepts/components/concepts-modal-breakdowns/concepts-modal-breakdowns-basic-form/concepts-modal-breakdowns-basic-form.vue'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

@Component({
    components: {
        VtGrid,
        ConceptsModalBreakdownsBasicForm
    }
})
export default class ConceptsModalBreakdowns extends Vue {
    @Ref() readonly conceptsModalBreakdownsBasicForm!: any

    private actionTitle !: string
    private selectedRows !: Array<object>
    private rowData!: Array<object>
    private columnDefs!: Array<object>
    private gridApi !: any

    constructor() {
        super()
        this.actionTitle = ''
        this.selectedRows = []
        this.columnDefs = [
            { type: 'customCheckbox' },
            {
                type: 'text',
                headerName: i18n.tc('configuration.sections.breakdown', 1),
                colId: 'breakdown',
                field: 'breakdown',
                minWidth: 190,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.tc('configuration.sections.unit', 1),
                colId: 'unit',
                field: 'unit',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.tc('configuration.grid.value'),
                colId: 'value',
                field: 'value',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.tc('configuration.sections.assayGroup', 1),
                colId: 'assayGroup',
                field: 'assayGroup',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.tc('configuration.grid.sampleTag'),
                colId: 'sampleTag',
                field: 'sampleTag',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            }
        ]
        this.rowData = [
            {
                breakdown: 'Desglose 1',
                unit: 'UCL',
                value: '3',
                assayGroup: 'Citología',
                sampleTag: 'Docencia'
            },
            {
                breakdown: 'Desglose 2',
                unit: 'UCL',
                value: '3',
                assayGroup: 'Citología',
                sampleTag: 'Docencia'
            },
            {
                breakdown: 'Desglose 3',
                unit: 'UCL',
                value: '3',
                assayGroup: 'Citología',
                sampleTag: 'Docencia'
            }
        ]
        this.gridApi = null
    }

    get gridOptions(): GridOptions {
        return {
            sideBar: gridSideBarConfig,
            rowModelType: AgGridRowModelType.CLIENT_SIDE,
            getContextMenuItems: this.getContextMenuItems,
            onGridReady: params => {
                this.onGridReady(params)
            },
            onRowSelected: params => {
                this.onRowSelected()
            }
        }
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        if (!params?.node) {
            return []
        } else {
            return [
                {
                    name: this.$t('configuration.actions.update').toString()
                },
                {
                    name: this.$t('configuration.actions.delete').toString()
                },
                {
                    name: this.$t('configuration.actions.activate').toString()
                },
                {
                    name: this.$t('configuration.actions.deactivate').toString()
                }
            ]
        }
    }

    onRowSelected() {
        this.selectedRows = this.gridApi.getSelectedRows()
    }

    onGridReady({ api }: any) {
        this.gridApi = api
    }

    showconceptsModalBreakdownsBasicForm(title: string) {
        this.actionTitle = title
        this.conceptsModalBreakdownsBasicForm.show()
    }
}
